import { render, staticRenderFns } from "./BoxSentimiento.vue?vue&type=template&id=2f026406&scoped=true&lang=pug"
import script from "./BoxSentimiento.vue?vue&type=script&lang=js"
export * from "./BoxSentimiento.vue?vue&type=script&lang=js"
import style0 from "./BoxSentimiento.vue?vue&type=style&index=0&id=2f026406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f026406",
  null
  
)

export default component.exports